import { useRouter } from 'next/router';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { ReactComponent as SvgDeal } from 'public/assets/icons/deal.svg';
import { Button } from 'components/blocks/Button';

import { Routes } from 'routes';
import { IResortShortReport } from 'api/region/types';
import styles from './styles.module.scss';

const ToLodgingRedirectButton = ({ resort }: { resort: IResortShortReport }) => {
  const { t } = useOTSTranslation('common');
  const router = useRouter();

  const onButtonClick = () => {
    router.push(Routes.resortTripPlanningLodging(resort));
  };

  return (
    <Button className={styles.redirectButton} onClick={onButtonClick}>
      <SvgDeal />
      <span>{t('region.openDates.lodging')}</span>
    </Button>
  );
};

export default ToLodgingRedirectButton;
